var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{attrs:{"center":_vm.position,"zoom":17,"map-type-id":"terrain"}},[_c('GmapMarker',{attrs:{"position":_vm.position}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }